<template>
  <div class="rj-page-card">
    <!-- <div class="rj-page-card__title">电汇查询</div> -->
    <div class="rj-page-card__content">
      <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
        <el-form-item label="业务实体:" prop="bussinessEntity">
          <el-select
            v-model="searchForm.bussinessEntity"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="option in businessEntity"
              :key="option.dictValue"
              :label="option.dictLabel"
              :value="option.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="收款编号:" prop="telegraphicTransferNum" clearable>
          <el-input v-model.trim="searchForm.telegraphicTransferNum" placeholder="请输入收款编号" />
        </el-form-item>
        <el-form-item label="收款日期:" prop="remittanceDate">
          <div class="rj-flex">
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.remittanceDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                clearable
              />
            </div>
            <div style="display: inline-block;width: 10px;text-align: center">
              -
            </div>
            <div class="rj-flex__item">
              <el-date-picker
                v-model="searchForm.remittanceEndDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                clearable
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="银行名称:" prop="importAccount">
          <el-select
            v-model="searchForm.importAccount"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="option in bankName"
              :key="option.dictValue"
              :label="option.dictLabel"
              :value="option.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="原始客户名称:" prop="importCompany" clearable>
          <el-input v-model.trim="searchForm.importCompany" placeholder="请输入原始客户名称" />
        </el-form-item>
        <el-form-item label="收款单已生成:" prop="isReceipt">
          <el-select
            v-model="searchForm.isReceipt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="option in generatedVoucher"
              :key="option.dictValue"
              :label="option.dictLabel"
              :value="option.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="已分配:" prop="isAssigned">
          <el-select
            v-model="searchForm.isAssigned"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="option in allocated"
              :key="option.dictValue"
              :label="option.dictLabel"
              :value="option.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="客户是否存在ERP:" prop="isErpHas">
          <el-select
            v-model="searchForm.isErpHas"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="option in isExistErp"
              :key="option.dictValue"
              :label="option.dictLabel"
              :value="option.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-button type="primary" :loading="isLoading" @click="doSearch">
          查询
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form>

      <div v-loading="isLoading" :data="tableData" border style="width: 100%;margin-top:10px">
        <el-table ref="multipleTable" :data="tableData" border style="width: 100%">
          <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
          <el-table-column prop="bussinessEntity" label="业务实体" align="left" fixed="left" />
          <el-table-column prop="importBank" label="银行名称" align="left" />
          <el-table-column prop="remittanceDate" label="收款日期" align="left" />
          <el-table-column prop="telegraphicTransferNum" label="收款编号" align="left">
            <template v-slot="{row}">
              <el-button type="text" class="el-btn-text-left" @click="showInfo(row.telegraphicTransferNum)">
                {{ row.telegraphicTransferNum }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="remittanceAmount" label="净收款额(元)" align="right" header-align="left" />
          <el-table-column prop="serviceFee" label="手续费(元)" align="right" header-align="left" />
          <el-table-column prop="importCompany" label="原始客户名称" align="left" />
          <el-table-column prop="newImportCompany" label="修改后客户名称" align="left" />
          <el-table-column prop="isAssigned" label="已分配" align="left" />
          <el-table-column prop="summary" label="摘要" align="left" />
          <el-table-column prop="isReceipt" label="已生成收款单" align="left" />
          <el-table-column label="操作" align="left" fixed="right" width="100">
            <template v-slot="{row}">
              <el-button type="text" @click="handel(row)">
                审核
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right;margin-top: 10px">
          <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.currentPage"
            layout="total, prev, pager, next, jumper,sizes"
            :total="page.total"
            hide-on-single-page
            @size-change="handerSizeChange"
            @current-change="handerCurrentChange"
          />
        </div>
        <el-dialog v-if="remittanceVisible" title="国内电汇详细信息" :visible.sync="remittanceVisible" width="800px">
          <remittance-info-box :id="telegraphicTransferNum" />
          <span slot="footer" class="dialog-footer">
            <el-button type="default" @click="remittanceVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
        <el-dialog title="审核修改客户名称" :visible.sync="toExamine" width="800px" @close="changeClose">
          <toExamine v-if="toExamine" ref="toExamine" :row-data="toExamineData" :is-finance="isFinance" />
          <span slot="footer" class="dialog-footer">
            <el-button type="default" :loading="isBtnLoading" @click="reject">驳回</el-button>
            <el-button type="primary" :loading="isBtnLoading" @click="agree">同意</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getDictData, toAuditList, handleApproval } from '@/API';
import remittanceInfoBox from './remittanceInfoBox';
import toExamine from './toExamine';
export default {
  data () {
    return {
      searchForm: {
        bussinessEntity: '',
        telegraphicTransferNum: '',
        remittanceDate: '',
        remittanceEndDate: '',
        importAccount: '',
        importCompany: '',
        isReceipt: '',
        isAssigned: '',
        isErpHas: ''

      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.remittanceDate) {
            let date = new Date(this.searchForm.remittanceDate);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      businessEntity: [],
      bankName: [],
      generatedVoucher: [],
      allocated: [],
      tableData: [],
      isExistErp: [],
      isLoading: false,
      remittanceVisible: false,
      isBtnLoading: false,
      toExamine: false,
      toExamineData: {},
      telegraphicTransferNum: '',
      isFinance: true,
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      }
    };
  },
  components: {
    remittanceInfoBox,
    toExamine
  },
  computed: {

  },
  mounted () {
    this.initData();
  },
  methods: {
    initData () {
      let parmas = ['business_entity', 'bank_name', 'generated_voucher', 'allocated', 'is_exist_erp'];
      getDictData(parmas).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          // 下拉列表基础数据
          json.data.forEach((item) => {
            if (item.dictType === 'business_entity') {
              this.businessEntity = item.dictDataVOS;
            }
            if (item.dictType === 'bank_name') {
              this.bankName = item.dictDataVOS;
            }
            if (item.dictType === 'generated_voucher') {
              this.generatedVoucher = item.dictDataVOS;
            }
            if (item.dictType === 'allocated') {
              this.allocated = item.dictDataVOS;
            }
            if (item.dictType === 'is_exist_erp') {
              this.isExistErp = item.dictDataVOS;
            }
          });
        }
      }).catch((err) => {
        console.log(err);
      });
      this.doSearch();
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.page.currentPage = val;
      this.doSearch();
    },
    doSearch () {
      this.isLoading = true;
      toAuditList({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        taskState: 1,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.isLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        } else {
          this.tableData = [];
          this.page.currentPage = 1;
          this.page.total = 0;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },
    agree () {
      let newName = this.$refs.toExamine.newName;
      if (newName === '') {
        this.$message.error('请输入修改后客户名称');
        return;
      }
      // let reason = this.$refs.toExamine.reason;
      // if (reason === '') {
      //   this.$message.error('请输入审批意见');
      //   return;
      // }
      let parmas = {
        telApprovalId: this.toExamineData.telApprovalId,
        approvalResult: true,
        opinion: this.$refs.toExamine.reason
      };
      this.isBtnLoading = true;
      handleApproval(parmas).then((res) => {
        this.isBtnLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('审核成功');
          this.changeClose();
          this.doSearch();
        } else {

        }
      }).catch(() => {
        this.isBtnLoading = false;
        this.isLoadingChangeSure = false;
      });
    },
    reject () {
      let newName = this.$refs.toExamine.newName;
      if (newName === '') {
        this.$message.error('请输入修改后客户名称');
        return;
      }
      let reason = this.$refs.toExamine.reason;
      if (reason === '') {
        this.$message.error('请输入审批意见');
        return;
      }
      let parmas = {
        telApprovalId: this.toExamineData.telApprovalId,
        approvalResult: false,
        opinion: this.$refs.toExamine.reason
      };
      this.isBtnLoading = true;
      handleApproval(parmas).then((res) => {
        this.isBtnLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('驳回成功');
          this.changeClose();
          this.doSearch();
        } else {

        }
      }).catch(() => {
        this.isBtnLoading = false;
        this.isLoadingChangeSure = false;
      });
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.page.currentPage = 1;
      this.searchForm.remittanceEndDate = '';
      this.doSearch();
    },
    handel (row) {
      this.toExamine = true;
      this.toExamineData = row;
    },
    // 修改关闭
    changeClose () {
      this.$refs.toExamine.newName = '';
      this.$refs.toExamine.fileList = [];
      this.$refs.toExamine.reason = '';
      this.toExamine = false;
    },
    showInfo (val) {
      this.telegraphicTransferNum = val;
      this.remittanceVisible = true;
    }
  }

};
</script>
<style lang="scss">
</style>
